import React, {Component} from "react"

class InputTextFilterWidget extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			value: props.placeholder,
			list: (props.list === null)? []: props.list,
			items: [],
			onItemSelected: props.onItemSelected,
			cStyle: props.cStyle,
			showId: props.showId
		}
		this.content = React.createRef()
		this.button = React.createRef()
		this.searchListItems = this.searchListItems.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
	}

	onItemSelected(id, val) {
		this.setState({value: val})
		if(this.state.onItemSelected != null) {
			this.state.onItemSelected(id, val)
		}
		this.content.current.className = 'hiddenmenu'
	}

	componentDidUpdate(prevProps) {
		if(this.props.placeholder != prevProps.placeholder) {
			this.setState({value: this.props.placeholder})
		}
	}

	searchListItems(str, isClicked) {
		if(this.props.list != null) {
			const items = []
			let searchString = str
			if(isClicked) {
				searchString = ''
			}
			this.props.list.map((v, i) => {
				const n = v.name.toLowerCase()
				if(n.includes(searchString)) {
					let disp = `${v.name.toUpperCase()}`
					if(this.state.showId) {
						disp += `, ${v.id}`
					}
					items.push(<a href="#" id={v.id} onClick={(e) => {
						this.onItemSelected(e.target.id, e.target.innerHTML)
					}}>{disp}</a>)
				}
			})
			this.setState({items: items, value: str})
		}
	}

	eventHandler(event, isClicked) {
		if(this.props.onChange) {
			this.props.onChange(event.target.value)
		}
		this.searchListItems(event.target.value, isClicked)
		let obj = this.content.current
		obj.className = 'dw-content'
		var p = {}
		p.x = obj.offsetLeft
		p.y = obj.offsetTop
		while (obj.offsetParent) {
			p.x = p.x + obj.offsetParent.offsetLeft
			p.y = p.y + obj.offsetParent.offsetTop
			if (obj == document.getElementsByTagName("body")[0]) {
				break
			}
			else {
				obj = obj.offsetParent
			}
		}
		const scrollHeight = window.innerHeight - event.clientY - 20
		const percentY = event.clientY / window.innerHeight
		if(percentY > 0.8) {
			this.content.current.style.bottom = "25px"
			return
		}
		else {
			this.content.current.style.bottom = "unset"
		}
		if(this.content.current.clientHeight > scrollHeight) {
			const innerContent = this.content.current.firstChild
			innerContent.style.height = scrollHeight + "px"
		}
	}

	render() {
		if(this.props.disabled && this.content.current != null) {
			this.content.current.className = 'hiddenmenu'
		}
		return(<div className="dropdown-widget" style={this.state.cStyle}
			onMouseLeave={() => {
				this.content.current.className = 'hiddenmenu'
				const innerContent = this.content.current.firstChild
				innerContent.style.height = "100%"
			}}>
			<input type='text' className="dw-button" ref={this.button} disabled={this.props.disabled}
				onChange={(event) => {
					this.eventHandler(event, false)
				}}
				onClick={(event) => {
					this.eventHandler(event, true)
				}}
			style={{width: '100%'}} value={this.state.value} />
			<div class="hiddenmenu" ref={this.content} onMouseLeave={() => {
				this.content.current.className = 'hiddenmenu'}}>
				<div className="dw-content-scroll">
				{this.state.items}</div></div>
		</div>)
	}
}

export default InputTextFilterWidget
